import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseCorrectQuestion } from '@/api/responses/proofread/questions'

export namespace QuestionsApi {
  /**
   * 設問正誤判定実施
   *
   * @param questionId 設問ID
   * @param questionInputs 設問解答情報(解答欄単位の配列)
   * @returns 正誤情報
   */
  export async function getCorrect(questionId: number, questionInputs: string[]): Promise<ApiResponseCorrectQuestion> {
    const params = {
      questionInputs: questionInputs,
    }
    return await ApiBase.get(`/proofread/questions/${questionId}/correct`, params)
  }
}
